import React from "react";
import styles from "./InputText.module.scss";
import clsx from "clsx";
import { ValidationInputState } from "../../ValidationInputState";

type Size = "default" | "big";
export interface InputTextProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size"> {
  ref?: React.Ref<HTMLInputElement>;
  variant?: "default" | "transparent" | "black";
  size?: Size;
  validationState?: ValidationInputState;
}

const InputTextBase: React.ForwardRefRenderFunction<
  HTMLInputElement,
  InputTextProps
> = (props, ref) => {
  const {
    variant = "default",
    className,
    validationState = undefined,
    size = "default",
    ...inputProps
  } = props;
  return (
    <input
      ref={ref}
      {...inputProps}
      aria-invalid={validationState == "error"}
      className={clsx(className, styles.input, {
        [styles.inputDefault]: variant == "default",
        [styles.inputBig]: size == "big",
        [styles.inputTransparent]: variant == "transparent",
        [styles.inputBlack]: variant == "black",
        [styles.stateInvalid]: validationState == "error"
      })}
    />
  );
};

export const InputText = React.forwardRef(InputTextBase);
